module.exports = __webpack_public_path__ + "b9346d93437b7c605d87d380c5f6c49a.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/intro-panel-texture-420.webp.png
// module id = 415
// module chunks = 0